//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.PriceAdditionalInfo

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The product price info model
* 
* @param bookingFee 
* @param presaleFee 
* @param taxAmount 
* @param totalAmount 
* @param priceAdditionInfos The list of additional price infos.
* @param shippingFee 
*/
@Serializable

data class CartPriceInfo (


      @SerialName(value = "bookingFee") @Required val bookingFee: Amount,


      @SerialName(value = "presaleFee") @Required val presaleFee: Amount,


      @SerialName(value = "taxAmount") @Required val taxAmount: Amount,


      @SerialName(value = "totalAmount") @Required val totalAmount: Amount,


      /* The list of additional price infos. */
    @SerialName(value = "priceAdditionInfos") val priceAdditionInfos: kotlin.collections.List<PriceAdditionalInfo>? = null,


      @SerialName(value = "shippingFee") val shippingFee: Amount? = null


) {




  }

